// ESSD 云盘类型
import { _$ } from 'kpc/components/utils';

export const ESSDVolumeProductType = [1155, 566, 565, 564, 501, 1156, 701, 702, 703];

// ESSD 数据盘
export const ESSD_Data_Type = [564, 565, 566, 501, 1155];

const ESSD_DATA_CODE = [1155, 566, 565, 564, 501];
// 老型号系统盘
const ESSD_SYSTEM_CODE = [1156, 701, 702, 703];

// 是否是 ESSD 数据盘
export function isESSDDataVolumeType(VolumeType) {
    // eslint-disable-next-line camelcase
    return ESSD_Data_Type.includes(VolumeType);
}

export const ESSDVolumeType = [
    'ESSD_Entry',
    'ESSD_SYSTEM_Entry',
    'ESSD_AutoPL',
    'ESSD_SYSTEM_AutoPL',
    'ESSD_PL0',
    'ESSD_SYSTEM_PL0',
    'ESSD_PL1',
    'ESSD_SYSTEM_PL1',
    'ESSD_PL2',
    'ESSD_SYSTEM_PL2',
    'ESSD_PL3',
    'DBSC_ESSD_PL0',
    'DBSC_ESSD_SYSTEM_PL0',
    'DBSC_ESSD_PL1',
    'DBSC_ESSD_SYSTEM_PL1'
];

export function isESSDVolumeType(VolumeType) {
    return ESSDVolumeType.includes(VolumeType);
}

// 专属集群类型
export const DBSCProductTypes = [1108, 1109, 1110, 1111, 1112, 1113];

// 专属集群云盘类型
// 1110: 基础型云盘
// 1111: 性能型
export const DbscEssdTypeIds = [1110, 1111];

export const DbscConstants = {
    DbscProductTypeIdList: [1112, 1113],
    DbscStatusGroup: [
        // {label: _$('全部'),value: 'all'},
        { label: _$('待交付'), value: 'preparing' },
        { label: _$('运行中'), value: 'running' },
        { label: _$('扩容中'), value: 'extending' },
        { label: _$('回收中'), value: 'recycling' }
    ],
    DbscTypeToIdMap: {
        DBSC_Standard: 1112,
        DBSC_Premium: 1113
    },
    DbscTypeMap: {
        DBSC_Standard: 'DBSC_ESSD_PL0',
        DBSC_Premium: 'DBSC_ESSD_PL1'
    },
    // dbsc 对应的云盘类型
    DbscTypeVolumnMap: {
        DBSC_Standard: 1110,
        DBSC_Premium: 1111
    },
    // 专属集群云硬盘
    DbscVolumeTypeList: ['DBSC_ESSD_PL0', 'DBSC_ESSD_PL1', 'DBSC_ESSD_SYSTEM_PL0', 'DBSC_ESSD_SYSTEM_PL1'],
    // 集群类型
    ClusterTypeGroup: [
        { label: _$('基础型专属块存储集群'), value: 'DBSC_Standard' },
        { label: _$('性能型专属块存储集群'), value: 'DBSC_Premium' },
        { label: _$('公有块存储集群'), value: 'Public' }
    ],
    getClusterTypeMap() {
        return convertGroupToMap(DbscConstants.ClusterTypeGroup);
    },
    getDbscStatusMap() {
        return convertGroupToMap(DbscConstants.DbscStatusGroup);
    }
};

export function convertGroupToMap(array) {
    const result = {};
    array.forEach((item) => {
        // 假设 label 是唯一的，否则需要处理重复的情况
        result[item.value] = item.label;
    });
    return result;
}

// 是否是老的系统盘类型：老款系统盘包含 'SYSTEM'
export function isOldSystemVolumeType(volume) {
    if (volume.VolumeCategory === 'system' && volume.VolumeType.includes('SYSTEM')) {
        return true;
    } else {
        return false;
    }
}

const OldEssdFormatMap = {
    'ESSD_SYSTEM_PL0': 'ESSD_PL0',
    'ESSD_SYSTEM_PL1': 'ESSD_PL1',
    'ESSD_SYSTEM_PL2': 'ESSD_PL2',
    'ESSD_SYSTEM_Entry': 'ESSD_Entry',
    'ESSD_SYSTEM_AutoPL': 'ESSD_AutoPL',
};

export function formatOldSystemEssd(volume) {
    return OldEssdFormatMap[volume.VolumeType];
}








